import { mutate } from 'swr';
import axios from 'axios';
import { GridRowId } from '@mui/x-data-grid-pro';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { getError } from '@shared/utils/helpers';
import { SERVICES } from '@shared/constants/apiConfig';
import { IShipment } from './types';

const BASE_URL = `/${SERVICES.DEAL}/deals/funded/shipments`;

export const requestCreateShipment = (user: IShipment[]) => {
  const url = `/${SERVICES.DOCUMENT}/fundedShipment`;
  const payload = {
    fundedShipmentRequest: user.map((v: IShipment) => {
      return {
        contactName: v.contactName,
        lc: v.lcName,
        lender: v.lenderName,
        payeeName: v.payeeName,
        payeeStreet: v.payeeStreet,
        payeeStreet2: v.payeeStreet2,
        payeeCity: v.payeeCity,
        payeeState: v.payeeState,
        payeeZip: v.payeeZip,
        payeePhoneNumber: v.payeePhoneNumber,
        isReturnLabelChecked: true,
        dealsInThisBatch: [
          {
            dealId: v.dealId,
            titleAgentName: v.titleAgent,
          },
        ],
        serviceType: 'STANDARD_OVERNIGHT',
      };
    }),
  };
  return mutate(url, async() => {
    try {
      const resp = await axios.post(url, payload);
      Notistack.successMessage('Successfully created funded shipment batch');
      return resp;
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestRemoveShipment = (ids: GridRowId[] = []) => {
  return mutate(BASE_URL, async() => {
    try {
      await axios.delete(BASE_URL, { data: ids });
      Notistack.successMessage('Shipment - Removed Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
